import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import type { RegionModalFooterProps } from './types';

export const RegionModalFooter = (props: RegionModalFooterProps) => {
  return (
    <AppFlex direction="row">
      <AppButton onClick={props.onSubmit}>{props.title}</AppButton>
      <AppButton type="outline" onClick={props.hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );
};
